import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";
import {SUGGESTED_REGIONS_POLAND} from "@pg-rp/common-constants";

import {ISearchStore} from "../reducers/search_reducer";
import {SearchTab} from "../types/SearchTab";

const getSuggestedRegionLabel = (id: number): string | undefined => {
    const suggestedRegion = SUGGESTED_REGIONS_POLAND[id];
    if (!suggestedRegion) return;

    return suggestedRegion.label;
};

export const getActiveItemLabel = (id: number | null, search: ISearchStore): string | undefined => {
    if (id == null) return;

    const {currentTabData, fetchOffersRequest, fetchPlacesRequest, fetchRegionsRequest, fetchVendorsRequest, formValues, offers, places, regions, vendors} =
        search;

    const inputValue = formValues.search.label;

    if (isEmpty(inputValue)) return getSuggestedRegionLabel(id);

    const {currentTab} = currentTabData;

    switch (currentTab) {
        case SearchTab.Holiday:
            return;
        case SearchTab.Offers:
            if (fetchOffersRequest !== RequestState.Success) return;

            return offers[id]?.name;
        case SearchTab.Places:
            if (fetchPlacesRequest !== RequestState.Success) return;

            return places[id]?.description;
        case SearchTab.Regions:
            if (fetchRegionsRequest !== RequestState.Success) return;

            return regions[id]?.full_name;
        case SearchTab.Vendors:
            if (fetchVendorsRequest !== RequestState.Success) return;

            return vendors[id]?.name;
        default: {
            const exhaustiveCheck: never = currentTab;

            return exhaustiveCheck;
        }
    }
};
import {isEmpty} from "@pg-mono/nodash";
import {RequestState} from "@pg-mono/request-state";
import {SUGGESTED_REGIONS_POLAND} from "@pg-rp/common-constants";

import {ISearchStore} from "../reducers/search_reducer";
import {SearchTab} from "../types/SearchTab";

const getSuggestedRegionLabel = (id: number): string | undefined => {
    const suggestedRegion = SUGGESTED_REGIONS_POLAND[id];
    if (!suggestedRegion) return;

    return suggestedRegion.label;
};

export const getActiveItemLabel = (id: number | null, search: ISearchStore): string | undefined => {
    if (id == null) return;

    const {currentTabData, fetchOffersRequest, fetchPlacesRequest, fetchRegionsRequest, fetchVendorsRequest, formValues, offers, places, regions, vendors} =
        search;

    const inputValue = formValues.search.label;

    if (isEmpty(inputValue)) return getSuggestedRegionLabel(id);

    const {currentTab} = currentTabData;

    switch (currentTab) {
        case SearchTab.Holiday:
            return;
        case SearchTab.Offers:
            if (fetchOffersRequest !== RequestState.Success) return;

            return offers[id]?.name;
        case SearchTab.Places:
            if (fetchPlacesRequest !== RequestState.Success) return;

            return places[id]?.description;
        case SearchTab.Regions:
            if (fetchRegionsRequest !== RequestState.Success) return;

            return regions[id]?.full_name;
        case SearchTab.Vendors:
            if (fetchVendorsRequest !== RequestState.Success) return;

            return vendors[id]?.name;
        default: {
            const exhaustiveCheck: never = currentTab;

            return exhaustiveCheck;
        }
    }
};
